import { APIRoute } from '@/modules/utils'
import { PublicProfile } from '@/data'
import { HydraCollection, IRI } from 'emt-library'

export const Route = (path: IRI): APIRoute => ({
  method: 'GET',
  path,
})

export type Response = HydraCollection<PublicProfile>
